import React, { ReactElement } from 'react';
import { Col, Row } from 'idsk-react-components';
import './successMessages.scss';
import { Message } from 'slovlex-idsk-react-components';
import { useSuccessMessageContext } from '../../context/SuccessMessageContext';

export default (): ReactElement => {
  const { messages, clearMessages } = useSuccessMessageContext();

  return messages && (
    <>
      { messages.map(message => (
        <Row key={message}>
          <Col>
            <Message className="success-message" type="success" headingSize="m" onClear={clearMessages}>
              {message}
            </Message>
          </Col>
        </Row>
      ))}
    </>
  );
};
